import { render, staticRenderFns } from "./GED.vue?vue&type=template&id=0f44a8a2"
import script from "./GED.vue?vue&type=script&lang=js"
export * from "./GED.vue?vue&type=script&lang=js"
import style0 from "./GED.vue?vue&type=style&index=0&id=0f44a8a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports